import type { InviteCardViewProps } from "./InviteCardView";
import type { InviteData, InviteViewPhase } from "./inviteTypes";
export interface InvitePreviewFixture {
  key: string;
  label: string;
  viewPhase: InviteViewPhase;
  props: Partial<InviteCardViewProps>;
}

const mockInviteData: InviteData = {
  id: "preview-token",
  role: "user",
  status: "active",
  createdAt: new Date().toISOString(),
  expiresAt: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
  createdBy: "Podscope",
  companyName: "Podscope",
  companySlug: "podscope",
  podcastTitle: "Mi Podcast de Prueba",
  podcastId: "preview-podcast",
  platform: "youtube",
  companyImageUrl: `${process.env.PUBLIC_URL ?? ""}/logo-no-background.png`,
  integrationSource: "podscope",
};

const mockPrixiInviteData: InviteData = {
  ...mockInviteData,
  createdBy: "Mi Canal Prixi",
  companyName: "Mi Canal Prixi",
  integrationSource: "prixi",
  podcastTitle: "Mi Canal en Prixi",
};

const mockLinkedAccount = {
  platform: "youtube" as const,
  accountId: "UCtq-cmZjW75ODxC250-p1bA",
  username: "Podscope",
  profileUrl: "https://www.youtube.com/channel/UCtq-cmZjW75ODxC250-p1bA",
};

const mockMetaInviteData: InviteData = {
  ...mockInviteData,
  platform: "meta",
  podcastId: "preview-podcast-1",
  podcastTitle: "El Sentido del Humor",
};

const mockCompanyPodcasts: import("./metaConnectUtils").CompanyPodcastOption[] = [
  {
    podcastId: "preview-podcast-1",
    title: "El Sentido del Humor",
    igHandle: "elsentidodelhumor",
    hasMetaConnection: false,
  },
  {
    podcastId: "preview-podcast-2",
    title: "Emisor Podcasting",
    igHandle: "emisorpodcasting",
    hasMetaConnection: true,
  },
  {
    podcastId: "preview-podcast-3",
    title: "La Junta",
    igHandle: "lajuntapodcast",
    hasMetaConnection: false,
  },
];

const mockMetaAssets: import("./metaConnectUtils").MetaIgLinkedAsset[] = [
  {
    pageId: "page-111",
    pageName: "El Sentido del Humor",
    igId: "ig-111",
    igUsername: "elsentidodelhumor",
    igProfilePictureUrl: undefined,
  },
  {
    pageId: "page-222",
    pageName: "Emisor Podcasting",
    igId: "ig-222",
    igUsername: "emisorpodcasting",
    igProfilePictureUrl: undefined,
  },
];

export const INVITE_PREVIEW_FIXTURES_RAW: InvitePreviewFixture[] = [
  {
    key: "loading",
    label: "loading",
    viewPhase: "loading",
    props: { inviteData: mockInviteData },
  },
  {
    key: "connect-youtube",
    label: "connect (YouTube)",
    viewPhase: "connect",
    props: { inviteData: mockInviteData, platform: "youtube" },
  },
  {
    key: "prixi-connect-youtube",
    label: "prixi_connect (YouTube)",
    viewPhase: "prixi_connect",
    props: { inviteData: mockPrixiInviteData, platform: "youtube" },
  },
  {
    key: "prixi-connect-error-youtube",
    label: "prixi_connect_error (YouTube OAuth)",
    viewPhase: "prixi_connect_error",
    props: {
      inviteData: mockPrixiInviteData,
      platform: "youtube",
      youtubeError: "Ocurrió un error durante la autorización de Google.",
    },
  },
  {
    key: "connect-error-youtube",
    label: "connect_error (YouTube OAuth)",
    viewPhase: "connect_error",
    props: {
      inviteData: mockInviteData,
      platform: "youtube",
      youtubeError: "Ocurrió un error durante la autorización de Google.",
    },
  },
  {
    key: "prixi-meta-page-id",
    label: "prixi_meta_page_id",
    viewPhase: "prixi_meta_page_id",
    props: {
      inviteData: { ...mockPrixiInviteData, platform: "meta" },
      platform: "meta",
      facebookAccessToken: "preview-token",
      metaNeedsPageId: true,
      metaPageId: "",
      termsAccepted: true,
    },
  },
  {
    key: "meta-page-id",
    label: "meta_page_id",
    viewPhase: "meta_page_id",
    props: {
      inviteData: { ...mockInviteData, platform: "meta" },
      platform: "meta",
      facebookAccessToken: "preview-token",
      metaNeedsPageId: true,
      metaPageId: "",
      termsAccepted: true,
    },
  },
  {
    key: "prixi-connecting-meta",
    label: "prixi_connecting (Meta)",
    viewPhase: "prixi_connecting",
    props: {
      inviteData: { ...mockPrixiInviteData, platform: "meta" },
      platform: "meta",
      facebookAccessToken: "preview-token",
      facebookLoading: true,
      termsAccepted: true,
    },
  },
  {
    key: "connecting-meta",
    label: "connecting (Meta)",
    viewPhase: "connecting",
    props: {
      inviteData: { ...mockInviteData, platform: "meta" },
      platform: "meta",
      facebookAccessToken: "preview-token",
      facebookLoading: true,
      termsAccepted: true,
    },
  },
  {
    key: "prixi-revalidating",
    label: "prixi revalidating",
    viewPhase: "revalidating",
    props: {
      inviteData: mockPrixiInviteData,
      isPlatformSuccess: true,
      linkedAccountLoading: true,
    },
  },
  {
    key: "revalidating",
    label: "revalidating",
    viewPhase: "revalidating",
    props: {
      inviteData: mockInviteData,
      isPlatformSuccess: true,
      linkedAccountLoading: true,
    },
  },
  {
    key: "success-youtube",
    label: "success (YouTube)",
    viewPhase: "success",
    props: {
      inviteData: mockInviteData,
      successParam: "youtube",
      isPlatformSuccess: true,
      linkedAccount: mockLinkedAccount,
    },
  },
  {
    key: "prixi-success-youtube",
    label: "prixi_success (YouTube)",
    viewPhase: "prixi_success",
    props: {
      inviteData: mockPrixiInviteData,
      successParam: "youtube",
      isPlatformSuccess: true,
      linkedAccount: mockLinkedAccount,
    },
  },
  {
    key: "already-connected",
    label: "already_connected",
    viewPhase: "already_connected",
    props: {
      inviteData: mockInviteData,
      linkedAccount: mockLinkedAccount,
    },
  },
  {
    key: "prixi-already-connected",
    label: "prixi_already_connected",
    viewPhase: "prixi_already_connected",
    props: {
      inviteData: mockPrixiInviteData,
      linkedAccount: mockLinkedAccount,
    },
  },
  {
    key: "disconnected",
    label: "disconnected",
    viewPhase: "disconnected",
    props: {
      inviteData: mockInviteData,
      disconnectedParam: "youtube",
    },
  },
  {
    key: "prixi-disconnected",
    label: "prixi_disconnected",
    viewPhase: "prixi_disconnected",
    props: {
      inviteData: mockPrixiInviteData,
      disconnectedParam: "youtube",
    },
  },
  {
    key: "expired",
    label: "expired",
    viewPhase: "expired",
    props: {
      inviteData: { ...mockInviteData, status: "expired" },
      unavailableReason: "expired",
    },
  },
  {
    key: "prixi-expired",
    label: "prixi_expired",
    viewPhase: "prixi_expired",
    props: {
      inviteData: { ...mockPrixiInviteData, status: "expired" },
      unavailableReason: "expired",
    },
  },
  {
    key: "prixi-unavailable-used",
    label: "prixi_unavailable (already_used)",
    viewPhase: "prixi_unavailable",
    props: {
      inviteData: { ...mockPrixiInviteData, status: "used" },
      unavailableReason: "already_used",
    },
  },
  {
    key: "prixi-unavailable-revoked",
    label: "prixi_unavailable (revoked)",
    viewPhase: "prixi_unavailable",
    props: {
      inviteData: mockPrixiInviteData,
      unavailableReason: "revoked",
    },
  },
  {
    key: "unavailable-used",
    label: "unavailable (already_used)",
    viewPhase: "unavailable",
    props: {
      inviteData: { ...mockInviteData, status: "used" },
      unavailableReason: "already_used",
    },
  },
  {
    key: "unavailable-revoked",
    label: "unavailable (revoked)",
    viewPhase: "unavailable",
    props: {
      inviteData: mockInviteData,
      unavailableReason: "revoked",
    },
  },
  {
    key: "meta_multichannel-success",
    label: "meta_multichannel: success",
    viewPhase: "success",
    props: {
      inviteData: { ...mockMetaInviteData, metaInviteMultiPodcastEnabled: true },
      platform: "meta",
      successParam: "meta",
      isPlatformSuccess: true,
      linkedAccount: {
        platform: "meta" as const,
        username: "elsentidodelhumor",
        accountId: "ig-111",
      },
      metaConnectedAccounts: [
        {
          igUsername: "elsentidodelhumor",
          igId: "ig-111",
          podcastTitle: "El Sentido del Humor",
          podcastId: "preview-podcast-1",
        },
        {
          igUsername: "emisorpodcasting",
          igId: "ig-222",
          podcastTitle: "Emisor Podcasting",
          podcastId: "preview-podcast-2",
        },
        {
          igUsername: "elsentidodelhumor",
          igId: "ig-111",
          podcastTitle: "La Junta",
          podcastId: "preview-podcast-3",
        },
      ],
    },
  },
  {
    key: "meta_multichannel-podcast-select-single",
    label: "meta_multichannel: select (1)",
    viewPhase: "meta_podcast_select",
    props: {
      inviteData: mockMetaInviteData,
      platform: "meta",
      termsAccepted: true,
      companyPodcasts: mockCompanyPodcasts.slice(0, 1),
      targetPodcastId: "preview-podcast-1",
      selectedPodcastIds: ["preview-podcast-1"],
    },
  },
  {
    key: "meta_multichannel-podcast-select-multi",
    label: "meta_multichannel: select (multi)",
    viewPhase: "meta_podcast_select",
    props: {
      inviteData: {
        ...mockMetaInviteData,
        metaInviteMultiPodcastEnabled: true,
      },
      platform: "meta",
      termsAccepted: true,
      companyPodcasts: mockCompanyPodcasts,
      targetPodcastId: "preview-podcast-1",
      selectedPodcastIds: ["preview-podcast-1", "preview-podcast-3"],
    },
  },
  {
    key: "meta_multichannel-mapping-single",
    label: "meta_multichannel: map (1→1)",
    viewPhase: "meta_mapping",
    props: {
      inviteData: mockMetaInviteData,
      platform: "meta",
      termsAccepted: true,
      facebookAccessToken: "preview-token",
      companyPodcasts: mockCompanyPodcasts.slice(0, 1),
      selectedPodcastIds: ["preview-podcast-1"],
      metaAssets: mockMetaAssets.slice(0, 1),
      metaMappings: [
        { pageId: "page-111", igId: "ig-111", podcastId: "preview-podcast-1" },
      ],
    },
  },
  {
    key: "meta_multichannel-mapping-multi",
    label: "meta_multichannel: map (2→2)",
    viewPhase: "meta_mapping",
    props: {
      inviteData: {
        ...mockMetaInviteData,
        metaInviteMultiPodcastEnabled: true,
      },
      platform: "meta",
      termsAccepted: true,
      facebookAccessToken: "preview-token",
      companyPodcasts: mockCompanyPodcasts.slice(0, 2),
      selectedPodcastIds: ["preview-podcast-1", "preview-podcast-2"],
      metaAssets: mockMetaAssets,
      metaMappings: [
        { pageId: "page-111", igId: "ig-111", podcastId: "preview-podcast-1" },
        { pageId: "page-222", igId: "ig-222", podcastId: "preview-podcast-2" },
      ],
    },
  },
  {
    key: "meta_multichannel-mapping-same-ig",
    label: "meta_multichannel: map (1→2)",
    viewPhase: "meta_mapping",
    props: {
      inviteData: {
        ...mockMetaInviteData,
        metaInviteMultiPodcastEnabled: true,
      },
      platform: "meta",
      termsAccepted: true,
      facebookAccessToken: "preview-token",
      companyPodcasts: mockCompanyPodcasts.slice(0, 2),
      selectedPodcastIds: ["preview-podcast-1", "preview-podcast-2"],
      metaAssets: mockMetaAssets.slice(0, 1),
      metaMappings: [
        { pageId: "page-111", igId: "ig-111", podcastId: "preview-podcast-1" },
        { pageId: "page-111", igId: "ig-111", podcastId: "preview-podcast-2" },
      ],
    },
  },
  {
    key: "fatal-network",
    label: "fatal (network — retry)",
    viewPhase: "fatal",
    props: {
      unavailableReason: "network",
      fatalError:
        "No pudimos conectar con el servidor. Verifica tu internet e intenta de nuevo.",
      showRetry: true,
    },
  },
  {
    key: "fatal-not-found",
    label: "fatal (not_found)",
    viewPhase: "fatal",
    props: {
      unavailableReason: "not_found",
      fatalError:
        "No encontramos una invitación con este enlace. Verifica que copiaste la URL completa.",
      showRetry: false,
    },
  },
];

const isPrixiPreviewFixture = (fixture: InvitePreviewFixture): boolean =>
  fixture.key.startsWith("prixi-") ||
  fixture.viewPhase.startsWith("prixi_") ||
  fixture.props.inviteData?.integrationSource === "prixi";

/** Prixi states first in dev gallery chip row and grid default order. */
export const INVITE_PREVIEW_FIXTURES: InvitePreviewFixture[] = [
  ...INVITE_PREVIEW_FIXTURES_RAW.filter(isPrixiPreviewFixture),
  ...INVITE_PREVIEW_FIXTURES_RAW.filter((f) => !isPrixiPreviewFixture(f)),
];

export function getInvitePreviewFixture(
  key: string,
): InvitePreviewFixture | undefined {
  return INVITE_PREVIEW_FIXTURES.find((f) => f.key === key);
}
